import { render } from "./DocumentListWidget.vue?vue&type=template&id=7635ae3d&scoped=true&ts=true"
import script from "./DocumentListWidget.vue?vue&type=script&lang=ts"
export * from "./DocumentListWidget.vue?vue&type=script&lang=ts"

import "./DocumentListWidget.vue?vue&type=style&index=0&id=7635ae3d&lang=scss&scoped=true"

import exportComponent from "/var/www/logiplanner_web_prod/logiplanner_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7635ae3d"]])

export default __exports__